module.exports = __webpack_public_path__ + "static/media/movie_genre.a3833eea.jpg";